const NEED_ITEM_DOWNLOAD = () => {
    return [
        {
            id: '0',
            check: false,
            large_key_down: '',
            backgroundColor: '',
            title: '',
            data: [
                { id: 1, check: false, key_down: 'id', title: 'CP番号', description: '' },
                { id: 2, check: false, key_down: 'campaign_url', title: 'キャンペーンURL', description: 'クラウドページの該当キャンペーンのURL' },
                { id: 3, check: false, key_down: 'created_at', title: '生成日', description: '履歴の最初の日付' }
            ]
        },
        {
            id: 1,
            check: false,
            large_key_down: 'overview',
            backgroundColor: '#b6d7a8',
            title: '１【概要情報】',
            data: [
                { id: 6, check: false, key_down: 'status', title: 'ステータス', description: '進捗ステータス' },
                { id: 7, check: false, key_down: 'name', title: 'キャンペーン名', description: 'キャンペーン名称' },
                { id: 8, check: false, key_down: 'zac_id', title: 'ZACID', description: 'ZACID' },
                { id: 9, check: false, key_down: 'sfid', title: 'SFID', description: 'SFID' },
                { id: 10, check: false, key_down: 'campaign_type', title: 'キャンペーン種別', description: 'キャンペーン種別' },
                { id: 11, check: false, key_down: 'categories', title: '応募種別', description: '応募種別' },
                { id: 12, check: false, key_down: 'overview_information', title: '自由記述', description: '' }
            ]
        },
        {
            id: 2,
            check: false,
            large_key_down: 'period',
            backgroundColor: '#b6d7a8',
            title: '２【期間関連】',
            data: [
                { id: 14, check: false, key_down: 'campaign_start_date', title: 'キャンペーン開始日', description: 'キャンペーン開始年月日（曜日）' },
                { id: 15, check: false, key_down: 'campaign_start_date_time', title: 'キャンペーン開始時間', description: 'キャンペーン開始時間' },
                { id: 16, check: false, key_down: 'campaign_end_date', title: 'キャンペーン終了日', description: 'キャンペーン終了年月日（曜日）' },
                { id: 17, check: false, key_down: 'campaign_end_date_time', title: 'キャンペーン終了時間', description: 'キャンペーン終了時間' },
                { id: 18, check: false, key_down: 'secretariat_start_date', title: '事務局開始日', description: '事務局開始年月日（曜日）' },
                { id: 19, check: false, key_down: 'secretariat_start_date_time', title: '事務局開始時間', description: '事務局開始時間' },
                { id: 20, check: false, key_down: 'secretariat_end_date', title: '事務局終了日', description: '事務局終了年月日（曜日）' },
                { id: 21, check: false, key_down: 'secretariat_end_date_time', title: '事務局終了時間', description: '事務局終了時間' },
                {
                    id: 22,
                    check: false,
                    key_down: 'receipt_expiration_start_date',
                    title: 'レシート有効期限開始日',
                    description: 'レシート有効期限開始年月日（曜日）'
                },
                {
                    id: 23,
                    check: false,
                    key_down: 'receipt_expiration_end_date',
                    title: 'レシート有効期限終了日',
                    description: 'レシート有効期限終了年月日（曜日）'
                },
                {
                    id: 24,
                    check: false,
                    key_down: 'condition_postcard',
                    title: 'ハガキ有効条件',
                    description: 'ハガキ応募の場合　当日消印有効・必着'
                },
                {
                    id: 25,
                    check: false,
                    key_down: 'year_end_schedule',
                    title: '年末年始休み',
                    description: '年末年始休み、日付含む（該当キャンペーンに関連する年末年始がある場合は表示）'
                },
                { id: 26, check: false, key_down: 'period_related', title: '自由記述', description: '' }
            ]
        },
        {
            id: 3,
            check: false,
            large_key_down: 'platform',
            backgroundColor: '#b6d7a8',
            title: '３【応募詳細】',
            data: [
                { id: 28, check: false, key_down: 'forms', title: 'WEB：応募フォームURL', description: '応募フォームURL' },
                { id: 29, check: false, key_down: 'application_condition_1', title: '●：応募条件①', description: '応募条件①（媒体ごとの）' },
                { id: 30, check: false, key_down: 'application_condition_2', title: '●：応募条件②', description: '応募条件②（媒体ごとの）' },
                {
                    id: 31,
                    check: false,
                    key_down: 'application_method',
                    title: '●：応募方法',
                    description: 'キャンペーンの応募種別に対応した応募方法（媒体ごとの）'
                },
                {
                    id: 32,
                    check: false,
                    key_down: 'offical_name_id_sns',
                    title: '●：公式アカウント名＆ID',
                    description: '公式アカウント名（公式アカウントID）（媒体ごとの）'
                },
                { id: 33, check: false, key_down: 'hashtag', title: '●：ハッシュタグ', description: 'CP指定ハッシュタグ（媒体ごとの）' },
                { id: 34, check: false, key_down: 'content_other', title: '自由記述', description: '媒体ごとの' }
            ]
        },
        {
            id: 4,
            check: false,
            large_key_down: 'purchase',
            backgroundColor: '#b6d7a8',
            title: '４【商品関連】',
            data: [
                { id: 36, check: false, key_down: 'purchase_conditions', title: '購買条件', description: '' },
                { id: 37, check: false, key_down: 'target_product_price', title: '対象商品金額', description: '対象商品金額入力' },
                { id: 38, check: false, key_down: 'target_product_quantity', title: '対象商品個数', description: '対象商品個数入力' },
                { id: 39, check: false, key_down: 'target_product_total_quantity', title: '対象商品合計金額', description: '対象商品合計金額入力' },
                { id: 40, check: false, key_down: 'target_product_total_circulation_amount', title: '流通合計金額', description: '流通合計金額入力' },
                {
                    id: 41,
                    check: false,
                    key_down: 'purchase_terms_and_price_details',
                    title: '購買条件と金額詳細',
                    description: `購買条件+金額詳細 \n【フォーマット】\n対象商品(個数)：●個\n流通合計金額：●●円`
                },
                { id: 42, check: false, key_down: 'target_product_list_1', title: '対象商品カテゴリ1', description: '対象商品のカテゴリ' },
                {
                    id: 43,
                    check: false,
                    key_down: 'target_product_list_2',
                    title: '対象商品カテゴリ2',
                    description: '対象商品のカテゴリのその先の分岐'
                },
                { id: 44, check: false, key_down: '', title: '商品関連自由記述', description: '対象商品名等の自由記述' },
                { id: 45, check: false, key_down: 'product_related', title: '自由記述', description: '' }
            ]
        },
        {
            id: 5,
            check: false,
            large_key_down: 'inform',
            backgroundColor: '#b6d7a8',
            title: '５【告知サイト関連】',
            data: [
                { id: 47, check: false, key_down: 'inform', title: 'キャンペーン告知', description: 'キャンペーン告知がされる媒体' },
                { id: 48, check: false, key_down: 'url', title: 'LPサイト', description: 'LP サイト' },
                { id: 49, check: false, key_down: 'url_publish_time_from', title: '公開開始期間', description: '公開開始年月日（曜日）時間' },
                { id: 50, check: false, key_down: 'url_publish_time_to', title: '公開終了期間', description: '公開終了年月日（曜日）時間' },
                { id: 51, check: false, key_down: 'information_ips', title: 'IPコンテンツ有無', description: '' },
                {
                    id: 52,
                    check: false,
                    key_down: 'information_ips_list',
                    title: 'IPコンテンツ詳細',
                    description: `キャラクター \n芸能人 \n声優 \nインフルエンサー \nその他`
                },
                { id: 53, check: false, key_down: 'information_ips_detail', title: 'IPコンテンツ詳細含自由記述', description: '' },
                {
                    id: 54,
                    check: false,
                    key_down: 'sponsor_informations',
                    title: 'キャンペーン主催情報',
                    description: 'キャンペーン主催情報の選択内容'
                },
                { id: 55, check: false, key_down: 'circulation_number', title: 'タイアップ流通数', description: '60企業' },
                {
                    id: 56,
                    check: false,
                    key_down: 'circulation_distribution',
                    title: 'タイアップ流通数報詳細',
                    description: 'イオン・サンドラッグ・●●'
                },
                { id: 57, check: false, key_down: 'up_manufacturers', title: 'タイアップメーカー数', description: '2企業' },
                { id: 58, check: false, key_down: 'up_manufacturers_name', title: 'タイアップメーカー数報詳細', description: '森永製菓・キリン' },
                { id: 59, check: false, key_down: 'announcement_site_related', title: '自由記述', description: '' }
            ]
        },
        {
            id: 6,
            check: false,
            large_key_down: 'event_prize_overview',
            backgroundColor: '#b6d7a8',
            title: '６【賞品・当選関連】',
            data: [
                { id: 61, check: false, key_down: 'total_number_of_win_prize', title: '総当選者数', description: '当選者数' },
                { id: 62, check: false, key_down: 'prize_shipping_period', title: '賞品進呈時期', description: '賞品進呈時期(発送時期・送付時期)' },
                { id: 63, check: false, key_down: 'prizes_and_winning_information', title: '自由記述', description: '' }
            ]
        },
        {
            id: 7,
            check: false,
            large_key_down: 'inquiry',
            backgroundColor: '#b6d7a8',
            title: '７【お問い合わせ関連】',
            data: [
                { id: 65, check: false, key_down: 'inquiry_office', title: 'お問い合わせ事務局名', description: 'キャンペーン名称+事務局' },
                {
                    id: 66,
                    check: false,
                    key_down: 'phone_setting_contact_information',
                    title: '事務局電話番号',
                    description: 'お問い合わせ事務局の電話番号'
                },
                {
                    id: 67,
                    check: false,
                    key_down: 'email_secretariat',
                    title: '事務局メールアドレス',
                    description: 'お問い合わせ事務局のメールアドレス'
                },
                {
                    id: 68,
                    check: false,
                    key_down: 'inquiry_dm_account',
                    title: 'お問い合わせDM対応アカウント',
                    description: `X：●●\nInstagram：●●`
                },
                { id: 69, check: false, key_down: 'contact_information_other', title: 'その他', description: '' },
                { id: 70, check: false, key_down: 'inquiries', title: '自由記述', description: '' }
            ]
        },
        {
            id: 8,
            check: false,
            large_key_down: 'folder_chat',
            backgroundColor: '#b6d7a8',
            title: '８【フォルダ・チャット関連】',
            data: [
                { id: 72, check: false, key_down: 'chatwork_rooms', title: 'Chatwork Room', description: '' },
                { id: 73, check: false, key_down: 'folder_project', title: '案件フォルダ', description: '案件フォルダ' },
                { id: 74, check: false, key_down: 'folder_quotation', title: '見積もりフォルダ', description: '見積もりフォルダ' },
                { id: 75, check: false, key_down: 'folder_chat_related', title: '自由記述', description: '' }
            ]
        },
        {
            id: 9,
            check: false,
            large_key_down: 'other',
            backgroundColor: '#b6d7a8',
            title: '９【その他】',
            data: [
                { id: 77, check: false, key_down: 'keywords', title: '検索キーワード', description: '' },
                { id: 78, check: false, key_down: 'memo', title: 'メモ欄', description: '' },
                { id: 79, check: false, key_down: 'associated_campaign', title: '付随キャンペーンID', description: '' },
                { id: 80, check: false, key_down: 'others', title: '自由記述', description: '' }
            ]
        },
        {
            id: 10,
            check: false,
            large_key_down: 'master_order_scope',
            backgroundColor: '#c9daf8',
            title: '１０【受注範囲＆パートナー＆ツール】',
            data: [
                {
                    id: 82,
                    check: false,
                    key_down: 'master_order_scope',
                    title: '受注範囲大項目',
                    description: `資料系 \nお問い合わせ \n応募収集 \n事務局関連 \n発送 \n制作関連 \nSNSアカウント関連`
                },
                {
                    id: 83,
                    check: false,
                    key_down: 'master_order_scope_112',
                    title: '受注範囲-資料系',
                    description: `応募規約 \nマニュアル \nFAQ \n配信文言 \n挨拶状 \nその他`
                },
                {
                    id: 84,
                    check: false,
                    key_down: 'master_order_scope_1',
                    title: '受注範囲-お問い合わせ+詳細',
                    description: `お問い合わせ \n-電話（03） \n-メール（独自ドメイン） \nDM \nその他`
                },
                {
                    id: 85,
                    check: false,
                    key_down: 'master_order_scope_14',
                    title: '受注範囲-応募収集+詳細',
                    description: `応募収集\n-WEBフォーム（独自ドメイン）\nはがき（）`
                },
                {
                    id: 86,
                    check: false,
                    key_down: 'master_order_scope_28',
                    title: '受注範囲-事務局関連+詳細',
                    description: `事務局関連 \n-通数報告（●●） \n-抽選（●●） \n-重複確認（●●） \n-購買確認（●●） \n-当選・発送データ作成（●●）`
                },
                {
                    id: 87,
                    check: false,
                    key_down: 'master_order_scope_82',
                    title: '受注範囲-発送+詳細',
                    description: `宅配便（●●） \n冷蔵（宅配便） \n冷凍（宅配便） \n郵便 \nDM便 \nその他`
                },
                {
                    id: 88,
                    check: false,
                    key_down: 'master_order_scope_93',
                    title: '受注範囲-制作関連+詳細',
                    description: `制作関連 \n-デザイン（●●）`
                },
                {
                    id: 89,
                    check: false,
                    key_down: 'master_order_scope_102',
                    title: '受注範囲-SNSアカウント関連+詳細',
                    description: `SNSアカウント関連 \n-アカウント作成（●●） \n告知投稿 \n告知配信 \n広告運用 \nその他`
                },
                {
                    id: 90,
                    check: false,
                    key_down: 'partners',
                    title: 'パートナー一覧',
                    description: `選択されているパートナーを一覧で表示 \nオペレーションセンター \nコールセンター香川`
                },
                {
                    id: 91,
                    check: false,
                    key_down: 'partners_order_scope_1',
                    title: 'パートナー：受注範囲-お問い合わせ',
                    description: `選択されているパートナーを一覧で表示 \nコールセンター香川`
                },
                {
                    id: 92,
                    check: false,
                    key_down: 'partners_order_scope_14',
                    title: 'パートナー：受注範囲-応募収集',
                    description: `選択されているパートナーを一覧で表示 \nオペレーションセンター`
                },
                {
                    id: 93,
                    check: false,
                    key_down: 'partners_order_scope_28',
                    title: 'パートナー：受注範囲-事務局関連',
                    description: `選択されているパートナーを一覧で表示 \nオペレーションセンター`
                },
                {
                    id: 94,
                    check: false,
                    key_down: 'partners_order_scope_82',
                    title: 'パートナー：受注範囲-発送',
                    description: `選択されているパートナーを一覧で表示 \nオペレーションセンター`
                },
                {
                    id: 95,
                    check: false,
                    key_down: 'tools',
                    title: 'ツール一覧',
                    description: `選択されているツールを一覧で表示 \nATELU \nWEBCAS`
                },
                {
                    id: 96,
                    check: false,
                    key_down: 'tools_order_scope_14',
                    title: 'ツール：受注範囲-応募収集',
                    description: `選択されているツールを一覧で表示 \nATELU`
                },
                {
                    id: 97,
                    check: false,
                    key_down: 'tools_order_scope_28',
                    title: 'ツール：受注範囲-事務局関連',
                    description: `選択されているツールを一覧で表示 \nWEBCAS`
                }
            ]
        },
        {
            id: 11,
            check: false,
            large_key_down: 'client_information',
            backgroundColor: '#f4cccc',
            title: '１１【お客様情報】',
            data: [
                { id: 99, check: false, key_down: 'client_order_source', title: '発注元', description: '発注元に選択されている企業名' },
                {
                    id: 100,
                    check: false,
                    key_down: 'client_generate_file',
                    title: 'エンドクライアント',
                    description: 'エンドクライアントに選択されている企業名'
                },
                { id: 101, check: false, key_down: 'client_order_source_type', title: '発注元の顧客種別', description: '' },
                { id: 102, check: false, key_down: 'client_generate_file_type', title: 'エンドクライアントの顧客種別', description: '' }
            ]
        },
        {
            id: 12,
            check: false,
            large_key_down: 'staff',
            backgroundColor: '#d9d2e9',
            title: '１２【事務局担当情報】',
            data: [
                { id: 104, check: false, key_down: 'sale_staff', title: '営業担当', description: '営業担当' },
                { id: 105, check: false, key_down: 'person_in_charge', title: 'ディレクションメイン担当', description: 'ディレクション担当のメイン' },
                {
                    id: 106,
                    check: false,
                    key_down: 'responsible_sub_persons_1',
                    title: 'ディレクションサブ1担当',
                    description: 'ディレクション担当のサブ１'
                },
                {
                    id: 107,
                    check: false,
                    key_down: 'responsible_sub_persons_2',
                    title: 'ディレクションサブ2担当',
                    description: 'ディレクション担当のサブ2'
                },
                { id: 108, check: false, key_down: 'project_management', title: '案件統括', description: '案件統括のメイン' },
                { id: 109, check: false, key_down: 'customer_team_pic', title: 'エスカレメイン担当', description: 'エスカレ担当のメイン' },
                { id: 110, check: false, key_down: 'customer_sub_person', title: 'エスカレサブ担当', description: 'エスカレ担当のサブ' },
                { id: 111, check: false, key_down: 'part_time_employees', title: 'アルバイト', description: 'アルバイト担当' }
            ]
        },
        {
            id: 13,
            check: false,
            large_key_down: 'prize_detail',
            backgroundColor: '#cfe2f3',
            title: '１３【賞品情報】',
            data: [
                { id: 113, check: false, key_down: '', title: '賞品個数', description: '登録されている賞品タイトルの個数' },
                { id: 114, check: false, key_down: '', title: '賞品タイトル+賞品名', description: '賞品タイトルと詳細' },
                { id: 115, check: false, key_down: '', title: '当選者人数', description: '' },
                { id: 116, check: false, key_down: '', title: '賞品種類', description: 'デジタルギフト・現物' },
                { id: 117, check: false, key_down: '', title: '賞品種類の詳細', description: '' }
            ]
        },
        {
            id: 14,
            check: false,
            large_key_down: 'result_registration',
            backgroundColor: '#fce5cd',
            title: '１４【実施結果登録】',
            data: [
                { id: 120, check: false, key_down: 'total_number_of_applications', title: '総応募数', description: '総応募数' },
                { id: 121, check: false, key_down: 'number_of_applications', title: '●：応募数', description: '応募数（媒体ごとの）' },
                { id: 122, check: false, key_down: 'total_number_of_inquiries', title: '総お問い合わせ数', description: '総お問い合わせ数' },
                { id: 123, check: false, key_down: 'number_of_inquiries', title: '●：お問い合わせ数', description: 'お問い合わせ数（媒体ごとの）' },
                { id: 124, check: false, key_down: 'total_platform_followers_number', title: 'SNSアカウントの友だち・フォロー数', description: '' },
                {
                    id: 125,
                    check: false,
                    key_down: 'platform_followers_number_detail',
                    title: '●：SNSアカウントの友だち・フォロー数',
                    description: '●～●'
                },
                {
                    id: 126,
                    check: false,
                    key_down: 'platform_followers_number',
                    title: '●：SNSアカウントの友だち・フォロー数の増減',
                    description: '●'
                },
                { id: 127, check: false, key_down: 'advertising_activity', title: '広告運用有無', description: 'ありなし' },
                { id: 128, check: false, key_down: 'social_platforms', title: '●：媒体＆費用', description: '（媒体ごとの）' },
                { id: 129, check: false, key_down: 'give_away_related', title: 'GA関連タグ埋め込み有無', description: 'ありなし' },
                { id: 130, check: false, key_down: 'campaign_entity_id', title: 'CAM-SAKU ID', description: '' }
            ]
        }
    ];
};

const MODAL_CONFIG = {
    title: '',
    model: false,
    scrollable: true,
    hideFooter: false,
    centered: false,
    validate: true,
    size: 'lg',
    titleBtnSave: 'ファイルのエクスポート',
    searchId: null
};

const TYPE_EXPORT = [
    {
        name: 'CSV',
        value: 'csv'
    },
    {
        name: 'XLSX',
        value: 'xlsx'
    }
];

function convertNtoBr(text) {
    if (typeof text !== 'string') return text;
    return text.replace(/\n/g, '<br>');
}

export { MODAL_CONFIG, TYPE_EXPORT, NEED_ITEM_DOWNLOAD, convertNtoBr };
